import * as React from "react";
import { Link } from "gatsby";

const HighlightArticle = ({ blog, slug }) => {
  return (
    <Link className="col-lg-12 mb-5 text-decoration-none" to={`/blog/${slug}`}>
      <div className="blog_item row rounded">
        <div className="col-lg-5 p-0">
          <img
            className="rounded object-fit-cover w-100 h-100 img-fluid"
            src={blog?.jetpack_featured_media_url}
            alt=""
          />
        </div>

        <div className="col-lg-7 p-3">
          <h2 className="text-black fs-2 fw-bold py-2">
            {blog?.title?.rendered}
          </h2>
          <p
            className="text-black fs-4 py-2"
            dangerouslySetInnerHTML={{
              __html: blog?.excerpt?.rendered,
            }}
          />
        </div>
      </div>
    </Link>
  );
};

export default HighlightArticle;
